<template>
    <div class="popcontent_item" style="float:left; margin-bottom: 10px; " :class="{'mr32':index%4!=3 && $route.name != 'company_intro', 'mr10': index%3!=2 && $route.name == 'company_intro' }" >        
        <MainPublicContentsItemYoutube  v-if="item.hasOwnProperty('youtube_title')" :item="item" ></MainPublicContentsItemYoutube>
        <MainPublicContentsItemArticle   v-else :item="item"  ></MainPublicContentsItemArticle>
        
    </div>
</template>

<script>
import MainPublicContentsItemArticle from "@/SPA/Main/Components/MainPublicContentsItemArticle.vue";
import MainPublicContentsItemYoutube from "@/SPA/Main/Components/MainPublicContentsItemYoutube.vue";
export default {
    props:["item","index"],
    components:{
        MainPublicContentsItemArticle,MainPublicContentsItemYoutube
    },
    data(){
        return{            
            }
    },
    methods:{
        open_youtube(){
                        
        },
    }

}
</script>

<style scoped lang="scss">
.mr32{
    margin-right: 32px;
}
.mr10{
    margin-right: 8px;
}
</style>



// WEBPACK FOOTER //
// src/SPA/Main/Components/MainPublicContentsItem.vue